/**
 * Konfiguriere hier die beiden Farben für den animierten Verlauf.
 */
export const GRADIENT_COLORS = ["#FF3D68", "#FAAD80"];
export const GRADIENT_COLORS_DARK = ["#0d0e20", "#620e2c"];
//export const GRADIENT_COLORS = ["#FF3D68", "#FAAD80"];
